module.exports = __webpack_public_path__ + "static/media/review.04adaac1.wav";